import React, { useEffect, useState, useContext } from 'react'
import ArrowForwardIosSharpIcon from '@mui/icons-material/ArrowForwardIosSharp'
import MuiAccordion from '@mui/material/Accordion'
import MuiAccordionSummary from '@mui/material/AccordionSummary'
import MuiAccordionDetails from '@mui/material/AccordionDetails'
import { BufferService, LoadingBar, LoadingContext } from 'src/M_Components'
import { useTranslation } from "react-i18next"

export default function LogPage({ toastMessages, roles }) {
    const { t } = useTranslation()
    const [expanded, setExpanded] = useState('')
    const [dataChangeLog, setDataChangeLog] = useState([])
    const bufferServiceChangeLog = new BufferService('Logs')
    const [isLoaded, setIsLoaded] = useState(true)
    const ctx = useContext(LoadingContext)

    //============================================================================================================
    // Handle accordion expansion
    //============================================================================================================
    const handleChange = (panel) => (event, newExpanded) => {
        setExpanded(newExpanded ? panel : false)
    }

    //============================================================================================================
    // Function to reformat date to DD/MM/YYYY
    //============================================================================================================
    function reformatDate(dateStr) {
        if (!dateStr) return ""
        const dArr = dateStr.split("-")
        return `${dArr[2]}/${dArr[1]}/${dArr[0]}`
    }

    //============================================================================================================
    // Function to format time to HH:MM:SS
    //============================================================================================================
    function formatTime(timeStr) {
        return timeStr?.substring(0, 8) ?? ""
    }

    //============================================================================================================
    // EFFECT
    // Fetch change logs on component mount
    //============================================================================================================
    useEffect(() => {
        bufferServiceChangeLog.get()
            .then((response) => {
                setDataChangeLog(response?.Data ?? [])
                setIsLoaded(false)
            })
            .catch(() => {
                setDataChangeLog([])
                toastMessages?.('error', '', t('ErrorLoadingData'))
                setIsLoaded(false)
            })
    }, [toastMessages, t])

    //============================================================================================================
    //Function to get color based on log type
    //============================================================================================================
    function getLogColor(typeName) {
        switch (typeName?.toUpperCase()) {
            case 'CREATE':
                return '#219653' // green for post/create
            case 'UPDATE':
                return '#f2994a' // orenge for put/update
            case 'DELETE':
                return 'var(--color-red)' // red for delete
            default:
                return 'var(--color-grey)' // grey for other types
        }
    }

    return (
        <>
            {isLoaded ? (
                <LoadingBar laneColor={`${ctx.primaryColor}`} />
            ) : (
                <div className='divAccordion'>
                    {dataChangeLog.map((group, index) => (
                        <MuiAccordion // Accordion for each change log group
                            disableGutters
                            elevation={1}
                            key={index}
                            square
                            expanded={expanded === `panel${index}`} // Control expansion state
                            onChange={handleChange(`panel${index}`)} // Handle expansion
                        >
                            <MuiAccordionSummary // Summary with date and expand icon
                                expandIcon={
                                    <ArrowForwardIosSharpIcon  // Expand icon
                                        sx={{
                                            fontSize: '0.9rem'
                                        }}
                                    />
                                }
                                sx={{ // Custom styles for summary
                                    '& .MuiAccordionSummary-expandIconWrapper.Mui-expanded': { transform: 'rotate(90deg)' },
                                    '& .MuiAccordionSummary-content': { marginLeft: '20px' },
                                    flexDirection: 'row-reverse',
                                }}
                            >
                                <p style={{ color: ctx.primaryColor, fontWeight: 'bold' }}>
                                    {t("LogDate")}: {reformatDate(group.LogDate)}
                                </p>
                            </MuiAccordionSummary>
                            <MuiAccordionDetails // Details section with logs
                                sx={{
                                    borderTop: '1px solid var(--color-grey)',
                                    borderBottom: '1px solid var(--color-grey)',
                                    padding: '20px'
                                }}
                            >
                                <div className='mainDiv'>
                                    {group.Logs.map((log) => ( // Map through logs in each group
                                        <div className='midleDiv' key={log.Id} // Key for each log
                                            style={{
                                                display: 'flex',
                                                alignItems: 'center',
                                                marginBottom: '10px'
                                            }}
                                        >
                                            <span className='logSpanTitle' // Span for log type with color
                                                style={{
                                                    backgroundColor: getLogColor(log.LogTypeName), // Get color based on log type
                                                    color: '#fff',
                                                    borderRadius: '5px',
                                                    padding: '3px 8px',
                                                    fontSize: '12px',
                                                    marginRight: '10px'
                                                }}
                                            >
                                                {log.LogTypeName /*Display  Log type name */}
                                            </span>
                                            <span>
                                                {log.Description /*Display  Log description */}
                                                ({formatTime(log.LogTime) /*Display  Log time */}) - {log.UserName  /*Display  Log user name */}
                                            </span>
                                        </div>
                                    ))}
                                </div>
                            </MuiAccordionDetails>
                        </MuiAccordion>
                    ))}
                </div>
            )}
        </>
    )
}
